export function formatCurrency(amount: number, maxDigits: number = 0): string {
    amount = +(amount.toFixed(maxDigits));
    return amount.toLocaleString();
}